var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"features-list"},_vm._l((_vm.featuresList),function(value,key){return _c('p',{key:key,staticClass:"features-list--item"},[_c('common-icon',{attrs:{"name":"check-blue","size":"small"}}),_vm._v(" "+_vm._s(value)+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }